exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Title__title___3ZPuH {\n  margin-left: 15px;\n  font-weight: 500;\n  color: #6b6767;\n  font-size: 1.5rem; }\n", ""]);

// exports
exports.locals = {
	"title": "Title__title___3ZPuH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Header/Title/Title.scss
// module id = 716
// module chunks = 0